import React, { Component } from 'react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import RhExtratoPanel from './RhExtratoPanel'

class RhColaboradorModal extends Component {
  render() {
    const { isOpen, toggle, colaborador, mesRef, onRefresh } = this.props

    if (!colaborador) return null

    return (
      <Modal isOpen={isOpen} toggle={toggle} size="xl">
        <ModalHeader toggle={toggle}>
          {colaborador.pf_nomeExibicao}
          <span className="text-muted small d-block font-weight-normal">
            {colaborador.pf_cargo || '—'}
            {' · '}
            {colaborador.dpto_nome || '—'}
          </span>
        </ModalHeader>
        <ModalBody>
          <RhExtratoPanel
            colaborador={colaborador}
            initialMesRef={mesRef}
            onRefresh={onRefresh}
          />
        </ModalBody>
      </Modal>
    )
  }
}

export default RhColaboradorModal
